import { type PropsWithChildren, type CSSProperties } from "react";

type ContainerProps = PropsWithChildren<{
  className?: string;
  style?: CSSProperties;
}>

export default function Container({ children, className = "", style }: ContainerProps) {
  return (
    <div className={className} style={style}>
      {children}
    </div>
  )
}
